<div class="t-popup popup-graphs" style="display: block; height: 100%">
  <div class="popup-close"></div>

  <div class="popup-frame">
    <div class="patient-ob-box popup-body">
      <!-- ============== Exam Search (Start) ============== -->
      <div class="h100 m-box" *ngIf="!isReports">
        <h2>Exam Search</h2>
        <div>
          <strong style="margin-right: 0.5em"> From: </strong>
          <input
            [matDatepicker]="startDatepicker"
            [(ngModel)]="startdate"
            [min]="searchmin"
            class="t-field t-field--date menstural-field"
            aria-labelledby="menstural_LMP"
            (click)="startDatepicker.open()"
            style="margin-right: 1em"
          />
          <mat-datepicker #startDatepicker></mat-datepicker>
          <strong style="margin-right: 0.5em"> Until: </strong>
          <input
            [matDatepicker]="endDatepicker"
            [(ngModel)]="enddate"
            [max]="searchmax"
            (click)="endDatepicker.open()"
            class="t-field t-field--date menstural-field"
            aria-labelledby="menstural_LMP"
            style="margin-right: 1em"
          />
          <mat-datepicker #endDatepicker></mat-datepicker>
        </div>
        <div class="h100 l-flex l-column">
          <div class="l-fg1">
            <div class="">
              <!-- new exam top (start) -->
              <div class="l-flex-c l-flex-w l-justify h50 new_exam-head">
                <label class="t-label-top">
                  <input
                    type="radio"
                    name="TEMP_name"
                    [(ngModel)]="etype"
                    class="custom-check"
                    value="All"
                    (click)="setVals('All')"
                  />
                  <i class="customInput-display"></i>
                  <span> All </span>
                </label>

                <label class="t-label-top">
                  <input
                    type="radio"
                    name="TEMP_name"
                    [(ngModel)]="etype"
                    class="custom-check"
                    value="Gastro"
                    (click)="setVals('Gastro')"
                  />
                  <i class="customInput-display"></i>
                  <span> Gastro </span>
                </label>
              </div>
              <!-- new exam top (end) -->
              <div class="linked-radios-list linked-radios-set">
                <ng-container *ngIf="etype == 'Gastro'">
                  <label
                    class="linked-radios-item"
                    (click)="setE($event, 'Gastroscopy')"
                  >
                    <input
                      type="checkbox"
                      name="Gastroscopy"
                      [checked]="exams['Gastroscopy']"
                    />
                    <span class="linked-radios-row">
                      <span class="l-fg1 linked-radios-title">Gastroscopy</span>
                    </span>
                  </label>
                  <label
                    class="linked-radios-item"
                    (click)="setE($event, 'Colonoscopy')"
                  >
                    <input
                      type="checkbox"
                      name="Colonoscopy"
                      [checked]="exams['Colonoscopy']"
                    />
                    <span class="linked-radios-row">
                      <span class="l-fg1 linked-radios-title">Colonoscopy</span>
                    </span>
                  </label>
                  <label
                    class="linked-radios-item"
                    (click)="setE($event, 'Sigmoidoscopy')"
                  >
                    <input
                      type="checkbox"
                      name="Sigmoidoscopy"
                      [checked]="exams['Sigmoidoscopy']"
                    />
                    <span class="linked-radios-row">
                      <span class="l-fg1 linked-radios-title"
                        >Sigmoidoscopy</span
                      >
                    </span>
                  </label>
                </ng-container>
              </div>
            </div>
          </div>

          <div class="l-flex l-flex-w l-just-center patient-ob-btns-row">
            <a
              class="btn-primary -exit"
              (click)="closed.emit(null)"
              style="padding-top: 1em"
            >
              Cancel
            </a>
            <button
              class="btn-primary -search"
              (click)="search()"
              *ngIf="cansearch"
            >
              Search
            </button>
          </div>
        </div>
      </div>
      <!-- ============== Exam Search (End) ============== -->

      <!-- ============== Reports (Start) ============== -->
      <div class="h100 m-box" *ngIf="isReports">
        <h2>Reports</h2>
        From
        <input
          [matDatepicker]="startDatepicker"
          [(ngModel)]="startdate"
          [max]="searchmax"
          class="t-field t-field--date menstural-field"
          aria-labelledby="menstural_LMP"
          (click)="startDatepicker.open()"
        />
        <mat-datepicker #startDatepicker></mat-datepicker>
        Until
        <input
          [matDatepicker]="endDatepicker"
          [(ngModel)]="enddate"
          [max]="searchmax"
          (click)="endDatepicker.open()"
          class="t-field t-field--date menstural-field"
          aria-labelledby="menstural_LMP"
        />
        <mat-datepicker #endDatepicker></mat-datepicker>
        <div class="h100 l-flex l-column">
          <div class="l-fg1">
            <div class="">
              <!-- ======= Report Scope (Start) ======= -->
              <!-- Scope only. "Status By HMO" is the one that goes looking for
                   trouble: its results carry the failure-case radios (no PRN,
                   not signed, not sent). "All" and "By HMO" just list what was
                   done in the period. -->
              <div class="l-flex-c l-flex-w h50 new_exam-head report-scope">
                <label class="t-label-top">
                  <input
                    type="radio"
                    name="reportMode"
                    [(ngModel)]="reportMode"
                    class="custom-check"
                    value="AllReports"
                  />
                  <i class="customInput-display"></i>
                  <span>All</span>
                </label>
                <label class="t-label-top">
                  <input
                    type="radio"
                    name="reportMode"
                    [(ngModel)]="reportMode"
                    class="custom-check"
                    value="HMO"
                  />
                  <i class="customInput-display"></i>
                  <span>
                    By HMO
                    <!-- "אחרים/ללא" is every exam the four above do not cover:
                         private, IDF and the unassigned. -->
                    <select
                      class="t-field t-select"
                      *ngIf="reportMode === 'HMO'"
                      [(ngModel)]="reportHmo"
                    >
                      <option value="Clalit">כללית</option>
                      <option value="Meuhedet">מאוחדת</option>
                      <option value="Leumit">לאומית</option>
                      <option value="Macabi">מכבי</option>
                      <option value="Others">אחרים/ללא</option>
                    </select>
                  </span>
                </label>
                <label class="t-label-top">
                  <input
                    type="radio"
                    name="reportMode"
                    [(ngModel)]="reportMode"
                    class="custom-check"
                    value="StatusHMO"
                  />
                  <i class="customInput-display"></i>
                  <span>
                    Status By HMO
                    <!-- The HMOs reports are actually sent to, then the rest -
                         private, IDF, unassigned - which no per-HMO option can
                         reach, and finally all of them in one go. -->
                    <select
                      class="t-field t-select"
                      *ngIf="reportMode === 'StatusHMO'"
                      [(ngModel)]="statusHmo"
                    >
                      <option value="Clalit">כללית</option>
                      <option value="Meuhedet">מאוחדת</option>
                      <option value="Leumit">לאומית</option>
                      <option value="Macabi">מכבי</option>
                      <option value="Others">אחרים/ללא</option>
                      <option value="All">כולם</option>
                    </select>
                  </span>
                </label>
              </div>
              <!-- ======= Report Scope (End) ======= -->
            </div>
          </div>
          <div
            class="l-flex l-flex-w l-just-center patient-ob-btns-row"
            style="margin-top: 1.5rem"
          >
            <a
              class="patient-ob-btn -exit"
              (click)="closed.emit(null)"
              style="padding-top: 1em"
            >
              Cancel
            </a>
            <button class="patient-ob-btn -search" (click)="search()">
              Search
            </button>
          </div>
        </div>
      </div>
      <!-- ============== Reports (End) ============== -->
    </div>
  </div>
</div>
